























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { ISegment } from "@/models/segments";
import { ListDisplayMode } from "@/data/constants";
import { UserMetaKeys } from "@/data/enums/users";
import SegmentResultsProvider from "@/components/app/admin/segments/segmentResultsProvider.vue";

@Component({
  components: {
    SegmentResultsProvider,
    "segment-results-config": () =>
      import("@/components/app/admin/segments/segmentResultsConfig.vue"),
    "cprods-grid-view": () =>
      import("@/components/app/global/contractProducts/cProdsGridView.vue"),
    "cprods-table-view": () =>
      import("@/components/app/global/contractProducts/cProdsTableView.vue"),
    "segment-results-to-cprods-provider-mapping": () =>
      import(
        "@/components/app/admin/segments/segmentResultsToCProdsProviderMapping.vue"
      ),
    "segment-results-to-clients-provider-mapping": () =>
      import(
        "@/components/app/admin/segments/segmentResultsToClientsProviderMapping.vue"
      ),
    "segment-results-to-orders-provider-mapping": () =>
      import(
        "@/components/app/admin/segments/segmentResultsToOrdersProviderMapping.vue"
      ),
    "add-segment-message": () =>
      import("@/components/app/admin/segments/addSegmentMessage.vue"),
    "orders-table-view": () =>
      import("@/components/app/global/orders/ordersTableView.vue"),
    "clients-view-switcher": () =>
      import("@/components/app/admin/clients/clientsViewSwitcher.vue")
  }
})
export default class SegmentResultsListing extends Vue {
  // Refs
  public declare $refs: {
    segmentResultsProvider: SegmentResultsProvider;
  };

  // Props
  @Prop({ default: "SRP" })
  public declare id: string;

  @Prop({ required: true })
  public segmentId!: ISegment["id"];

  @Prop({ default: null })
  public segmentTypeHint!: ISegment["type"];

  @Prop({ default: () => () => ({}) })
  public routeFilters!: (
    vm?: SegmentResultsListing
  ) => Record<string, string | number | boolean>;

  @Prop({ default: () => ({}) })
  public parentFilters!: Record<string, string | number | boolean>;

  @Prop({ default: () => () => [] })
  public availableFilters!: (vm?: SegmentResultsListing) => IFilter[];

  @Prop({ default: () => () => [] })
  public availableSorters!: (vm?: SegmentResultsListing) => ISorter[];

  @Prop({ default: null })
  public newSegmentRouteName!: string;

  @Prop({ default: true })
  public allowCreateSegment!: string;

  @Prop({ required: true })
  public defaultDisplayMode!: ListDisplayMode;

  @Prop({ default: () => undefined })
  public displayModes!: ListDisplayMode[];

  @Prop({ default: undefined })
  public displayModeStoragePath!: UserMetaKeys;

  // Data
  public displayMode = this.defaultDisplayMode || "";
  public segmentAvailableFilters: IFilter[] = [];

  // Life-cycle methods

  public created() {
    this.segmentAvailableFilters = this.availableFilters(this);
  }

  // Computed

  public get isDisplayModeTable() {
    return this.displayMode === ListDisplayMode.TABLE;
  }

  public get isDisplayModeGrid() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get segmentsManualFilters() {
    return {
      ...this.parentFilters,
      ...this.routeFilters(this)
    };
  }

  public get segmentAvailableSorters() {
    return this.availableSorters(this);
  }

  // Methods

  @Watch("parentFilters", { deep: true })
  public onParentFiltersChange() {
    this.$refs.segmentResultsProvider.reloadData();
  }
}
